import React from 'react'
import BaseForm from './base-form.component'
import StyledStepFrom from './styled-step-from.component'
import PasswordForm from './password-form.component'

export default class StepFourPasswordForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<PasswordForm
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
				/>
			</StyledStepFrom>
		)
	}
}
